/* eslint-disable max-len */
export default {
  MESSAGES: {
    CURRENT_DELIVERY_STATUS: 'Estado actual del pedido',
    DATE: 'Fecha',
    DELIVERY_HISTORY: 'Historial de entrega',
    HOUR: 'Hora',
    OBSERVATIONS: 'Observaciones',
    STATUS: 'Estado'
  }
};
